import { Subheading } from '@Components/Typography/Typography';
import styled from 'styled-components';

export const CardWrapper = styled.div`
	padding: 8px 16px;
`;
export const Title = styled(Subheading)`
	padding-bottom: 16px;
`;
